import { clansEndpoints } from "./clans.api"

export const {
  useGetClansQuery,
  useGetMembersQuery,
  useGetDefaultAvatarsQuery,
  useCreateClanMutation,
  useGetUserClanQuery,
  useLeaveClanMutation,
  useChangeRoleMutation,
  useKickMemberMutation,
  useEnterClanMutation,
  useGetClanBuildingsQuery,
  useGetClanRequestsQuery,
  useApproveRequestMutation,
  useRejectRequestMutation,
  useGetClanByIdQuery,
  useGetBuildingUpgradeQuery,
  useGetBuildingByTypeQuery,
  useUpdateClanMutation,
  useBuildBuildingMutation,
  useUpgradeBuildingMutation,
  useGetClanBuildingInstanceQuery,
  useDonateToBankMutation,
  useDeleteClanMutation,
  useGetClanTransactionsQuery,
  useGetUserRequestsQuery,
  useGetClanPositionQuery,
  useGetClanLogsQuery,
  useGetClanTaxesQuery,
  useClaimClanTaxesMutation,
  useGetClanShortByUserIdQuery,
  useTransferClanMutation,
  endpoints: { getUserClan }
} = clansEndpoints
